// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2cbE4","title":"Images90_title__e7bNv","images":"Images90_images__27KWU"};